import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { withTranslation } from 'shared/utils/withTranslation'

import FormatUtils from 'shared/utils/format'

export class ProductPrice extends Component {
  static displayName = 'ProductPrice'

  static propTypes = {
    chargeLabel: PropTypes.string,
    priceInCents: PropTypes.number,
    currency: PropTypes.object,
    show: PropTypes.bool,
    productType: PropTypes.string,
    priceType: PropTypes.string,
    t: PropTypes.func
  }

  static defaultProps = {
    productType: 'rental'
  }

  render = () => {
    const { priceInCents, chargeLabel, productType, priceType, t } = this.props

    if (this.props.show) {
      return (
        <span className="bq-price-details">
          {(priceType !== 'fixed' || productType !== 'rental') && (
            <span className="bq-duration">
              {(productType === 'rental' || productType === 'bundle') && chargeLabel}
              {productType === 'consumable' && <b>{t('user.store.buy')}</b>}
            </span>
          )}
          <span className="bq-price">
            {FormatUtils.money(priceInCents, this.props.currency)}
          </span>
        </span>
      )
    } else {
      return false
    }
  }
}

const mapStateToProps = (state, props) => {
  const usePrices = state.settings.get('store.use_prices')
  const hasPrice = props.priceInCents != null && props.priceInCents >= 0

  return {
    currency: state.client.currency && state.client.currency.toJS(),
    show: usePrices && hasPrice
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {}
}

const reduxComponent = reduxConnect(mapStateToProps, mapDispatchToProps)(ProductPrice)

export default withTranslation('user')(reduxComponent)
